// JS file for ProductItem

import '@main';
import '@vendor/@fancyapps/ui/dist/fancybox.umd.js?1bea164b822ef8320667d940';

u.importCSS('@vendor/@fancyapps/ui/dist/fancybox.css');

// Header
const header = $('.j-header');
const banner = $('.j-product-banner');
const menu = $('.j-product-menu');
const feature = $('.c-product__feature');

$(window).on('scroll', function () {
  let top = $(document).scrollTop();

  if (top > 200) {
    banner.removeClass('h-hide');
  } else {
    banner.addClass('h-hide');
  }
}).trigger('scroll');

// Menu
jQuery(function ($) {
  const menuItem = $('.j-menu-item');

  menuItem.on('click', function () {
    const target = $(this).data('target');

    $('html, body').animate(
      {
        scrollTop: $(target).offset().top - 330
      }
    );
  });

  menuItem.each(function (e, i) {
    activeMenu($(i).data('target'));
  });

  $(window).on('scroll', function () {
    menuItem.each(function (e, i) {
      activeMenu($(i).data('target'));
    });
  });

  function activeMenu(selector) {
    let target = $(selector);
    let rect = target[0].getBoundingClientRect();

    if (window.innerHeight - rect.top > (window.innerHeight * 0.4)
      && (window.innerHeight - rect.bottom) <= (window.innerHeight - 200)) {
      menuItem.removeClass('active');

      let menu = '.j-menu-item[data-target = "' + selector + '"]';

      $(menu).addClass('active');
    }
  }

  $('.j-download-collapse').on('click', function () {
    const icon = $(this).find('i');

    if (icon.hasClass('fa-plus')) {
      icon.removeClass('fa-plus');
      icon.addClass('fa-minus');
    } else {
      icon.removeClass('fa-minus');
      icon.addClass('fa-plus');
    }
  });
});
